export const REQUEST_CHECKLIST = 'zola/checklist/REQUEST_CHECKLIST';
export const UPDATE_CHECKLIST = 'zola/checklist/UPDATE_CHECKLIST';
export const RECEIVE_CHECKLIST = 'zola/checklist/RECEIVE_CHECKLIST';
export const ADD_TASK = 'zola/checklist/ADD_TASK';
export const UPDATE_TASK = 'zola/checklist/UPDATE_TASK';
export const REMOVE_TASK = 'zola/checklist/REMOVE_TASK';
export const RECEIVE_TASK = 'zola/checklist/RECEIVE_TASK';
export const REQUEST_TEMPLATES = 'zola/checklist/REQUEST_TEMPLATES';
export const RECEIVE_TEMPLATES = 'zola/checklist/RECEIVE_TEMPLATES';
export const SELECT_TASK = 'zola/checklist/SELECT_TASK';
export const UNSELECT_TASK = 'zola/checklist/UNSELECT_TASK';
export const TOGGLE_COMPLETED = 'zola/checklist/TOGGLE_COMPLETED';
export const INC_ONBOARD_STEP = 'zola/checklist/INC_ONBOARD_STEP';
export const DEC_ONBOARD_STEP = 'zola/checklist/DEC_ONBOARD_STEP';
export const TOGGLE_ONBOARD = 'zola/checklist/TOGGLE_ONBOARD';
export const REQUEST_STATS = 'zola/checklist/REQUEST_STATS';
export const RECEIVE_STATS = 'zola/checklist/RECEIVE_STATS';
export const RESET_CHECKLIST = 'zola/checklist/RESET_CHECKLIST';



/** WEBPACK FOOTER **
 ** ./src/actions/types/ChecklistActionTypes.js
 **/